import { useQuery } from '@tanstack/react-query'
import {
	Space,
	Card,
	Input,
	Table,
	message,
	Button,
	Spin,
	Modal,
	Pagination,

} from 'antd'
import { Camera,RefreshCcw} from 'lucide-react'
import moment from 'moment'
import React, { useState, useEffect, useRef, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'

import CameraScanner from '@components/CameraScanner'
import Layout from '@components/Layout'
import ErrorModalWithTimer from '@components/Modal/ErrorModalWithTimer'
import SelectServiceModal from '@components/Modal/SelectServiceModal/index.jsx'
import SuccessModalWithTimer from '@components/Modal/SuccessModalWithTimer'
import ViewProductionWorkersModal from '@components/Modal/viewProductionWorkerModal.jsx'
import { http } from '@services/http'
import { columnProductionWorkers } from '@utils/columns.jsx'
import {
	fetchProductionWorkers,
	fetchProductionWorkersInProcess,
} from '@utils/fetchData.js'

import './table.css'
import {
	handleMarshrutWorkers,
	handleNavigateSeriesProdWorkers,
} from '@utils/navigateToPdf'
import {
} from '@utils/numberWithSpaces'
import { changePagination, changePageSize } from '@utils/pagination'
import {
	switchBgColor,
	meaningOfBg,
} from '@utils/switchBgProductionsTables'
import {
	calculateDurationString,
} from '@utils/time'
import { debouncedSet } from '@utils/debounce.js'



const ProductionManagement = () => {
	const { t } = useTranslation()
	const { roleNames, getMe } = useSelector((state) => state.main)

	const serviceCodes = getMe?.workerServiceCodes?.split(',') || []
	const workerDeps = getMe?.workerDeps?.split(',') || []

	const successRef = useRef()
	const errorRef = useRef()

	const [currentPage, setCurrentPage] = useState(0)
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [docNum, setDocNum] = useState('')
	const [inputDocNum, setInputDocNum] = useState('')
	const [startDate, setStartDate] = useState('')
	const [isLoaderModalVisible, setIsLoaderModalVisible] = useState(false)
	const [endDate, setEndDate] = useState(
		moment().add(1, 'year').endOf('year').format('YYYY-MM-DD'),
	)

	const [pageSize, setPageSize] = useState('50')
	const [lastScanTime, setLastScanTime] = useState(null)
	const [mappedData, setMappedData] = useState([])
	const [isStarted, setIsStarted] = useState('')
	const [isReady, setIsReady] = useState('No')
	const [isReadyForNextStage, setIsReadyForNextStage] = useState('Yes')
	const [loadingData, setLoading] = useState([])
	const [loadingDataForTable, setLoadingDataForTable] = useState([])
	const [isRefetch, setIsRefetch] = useState(false)
	const [isBroken, setIsBroken] = useState('')

	const [selectServiceModal, setSelectServiceModal] = useState(false)
	const [selectedService, setSelectedService] = useState('')
	const [isCameraModalVisible, setIsCameraModalVisible] = useState(false)

	const {
		data: productionWorkersData = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: [
			'productionWorkersReady',
			currentPage,
			pageSize,
			startDate,
			endDate,
			docNum,
			isStarted,
			isReady,
			isReadyForNextStage,
					workerDeps || "",
			// roleNames.includes('admin') ? '' : getMe?.u_Service,
			selectedService,
			isBroken,
		],
		queryFn: fetchProductionWorkers,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
		enabled: !!selectedService,
	})

	const {
		data: productionWorkersInProcess = [],
		isLoading: isLoadingInProcess,
		refetch: inProcessRefetch,
	} = useQuery({
		queryKey: [
			'productionWorkersInProcess',
		workerDeps || "",
			selectedService,
		],
		queryFn: fetchProductionWorkersInProcess,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
		enabled: !!selectedService,
	})


	useEffect(() => {
		if (productionWorkersData?.length > 0) {
			setMappedData(productionWorkersData)
			setLoadingDataForTable(
				Array.from({ length: productionWorkersData.length }).map(
					() => false,
				),
			)
		} else {
			setMappedData([])
			setLoadingDataForTable([])
		}
	}, [productionWorkersData])

	useEffect(() => {
		if (productionWorkersInProcess?.length > 0) {
			setLoading(
				Array.from({ length: productionWorkersInProcess.length }).map(
					() => false,
				),
			)
		} else {
			setLoading([])
		}
	}, [productionWorkersInProcess])

	useEffect(() => {
		if (!getMe?.workerServiceCodes) {
			message.warning(t('youDontHaveAnyServices'))
			setSelectServiceModal(false)
		} else if (serviceCodes.length === 1) {
			setSelectServiceModal(false)
			setSelectedService(serviceCodes[0])
		} else {
			setSelectServiceModal(true)
			setSelectedService('')
		}
	}, [])

	const startTimePatch = async (data, index) => {
				const currentTime = moment().format('HH:mm:ss')
				const currentDate = moment().format('YYYY-MM-DD') + "T00:00:00.000Z"

		const documentLines = data?.map((item) => {
			return {
				salesOrderDocEntry: item.salesOrderDocEntry,
				code: item.code,
				priority: item.priority,
				status: item.status,
				description: item.description,
				startTime: currentTime,
				docDate:currentDate,
				endTime: item.endTime ,
				endDate: item.endDate ,
				wastedTime: item.wastedTime,
				isStarted: 'Yes',
				isReady: item.isReady,
				isReadyForNextStage: item.isReadyForNextStage,
				worker: getMe?.employeeId,
				serialNumber: item.serialNumber,
				service: item.service,
				quantity: item.quantity,
				coefficient: item.coefficient,
				electricityCost: item.electricityCost,
				machineCost: item.machineCost,


			}
		})

		// const patchingData = {
		// 	...documentLines,
		// }
		const newTableLoadingData = [...loadingDataForTable]
		newTableLoadingData[index] = true
		setLoadingDataForTable(newTableLoadingData)

		try {
			await http
				.patch(`api/pots/update-pots`, documentLines)
				.then((res) => {
					inProcessRefetch()
					refetch()
					setTimeout(() => {
						refetch()
						inProcessRefetch()
					}, 5000)

					setTimeout(() => {
						refetch()
						inProcessRefetch()
					}, 15000)
					setIsRefetch(!isRefetch)
				})
			setIsLoaderModalVisible(false)
					successRef.current?.open(t('sucStarted'))
		} catch (error) {
			errorRef.current?.open(error?.response?.data?.message)
			setIsLoaderModalVisible(false)
		} finally {
			newTableLoadingData[index] = false
			setLoadingDataForTable(newTableLoadingData)
			setIsLoaderModalVisible(false)
		}
	}


	const markBroken = async (data, index) => {

		const newTableLoadingData = [...loadingDataForTable]
		newTableLoadingData[index] = true
		setLoadingDataForTable(newTableLoadingData)

		const body = {
  salesOrderDocEntry: data?.salesOrderDocEntry,
  serialNumber: data?.serialNumber
}

		try {
			await http
				.patch(`api/pots/mark-broken`,body)
				.then((res) => {
					inProcessRefetch()
					refetch()
					setTimeout(() => {
						refetch()
						inProcessRefetch()
					}, 5000)

					setTimeout(() => {
						refetch()
						inProcessRefetch()
					}, 15000)
					setTimeout(() => {
						refetch()
						inProcessRefetch()
					}, 25000)
					setIsRefetch(!isRefetch)
				})
			setIsLoaderModalVisible(false)
						// successRef.current?.open(t('sucMarked'))

		} catch (error) {
			errorRef.current?.open(error?.response?.data?.message)
			setIsLoaderModalVisible(false)
		} finally {
			newTableLoadingData[index] = false
			setLoadingDataForTable(newTableLoadingData)
			setIsLoaderModalVisible(false)
		}
	}

	const endTimePatch = async (
		data,
		endTime,
		duration,
		serialNumber,
		indexForTable,
		indexForSerial,
	) => {
		const docLines = data
		const currentTime = moment().format('HH:mm:ss')
		const currentDate = moment().format('YYYY-MM-DD') + "T00:00:00.000Z"

		const patchingData = [
			{
				salesOrderDocEntry: docLines.salesOrderDocEntry,
				priority: docLines.priority,
				code: docLines.code,
				status: docLines.status,
				description: docLines.description,
				wastedTime: duration,
				isStarted: 'Yes',
				isReady: 'Yes',
				isReadyForNextStage: 'Yes',
				worker: getMe?.employeeId,
				serialNumber: docLines.serialNumber,
				service: docLines.service,
				quantity: docLines.quantity,
				coefficient: docLines.coefficient,
				electricityCost: docLines.electricityCost,
				machineCost: docLines.machineCost,
				docDate:docLines.docDate,
								startTime: docLines.startTime,
				endTime: currentTime,
				endDate: currentDate,

			},
		]

		const newTableLoadingData = [...loadingDataForTable]
		newTableLoadingData[indexForTable] = true
		setLoadingDataForTable(newTableLoadingData)

		const allLoading = [...loadingData]
		allLoading[indexForSerial] = true
		setLoading(allLoading)

		try {
			await http
				.patch(`api/pots/update-pots`, patchingData)
				.then((res) => {
					// patchStatusReadyForNextStage(
					// 	data,
					// 	serialNumber,
					// 	indexForTable,
					// 	indexForSerial,
					// )
					refetch()
					inProcessRefetch()
					setTimeout(() => {
						inProcessRefetch()
						refetch()
					}, 5000)

					setTimeout(() => {
						inProcessRefetch()
						refetch()
					}, 15000)
					setIsRefetch(!isRefetch)
				})
			setIsLoaderModalVisible(false)
			successRef.current?.open(t('sucSaved'))
		} catch (error) {
			setIsLoaderModalVisible(false)
			errorRef.current?.open(error?.response?.data?.message)
		} finally {
			newTableLoadingData[indexForTable] = false
			setLoadingDataForTable(newTableLoadingData)
			allLoading[indexForSerial] = false
			setLoading(allLoading)
		}
	}

	const handleFilter = (meaning) => {
		if (meaning === 'Done') {
			setIsReady('Yes')
			setIsStarted('Yes')
			setIsReadyForNextStage('')
			setStartDate('')
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
			setIsBroken('')
		}else if (meaning === 'Broken') {
			setIsReady('')
			setIsStarted('')
			setIsReadyForNextStage('')
			setStartDate('')
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
			setIsBroken('Y')
		} else if (meaning === 'InProcess') {
			setIsReadyForNextStage('Yes')
			setIsReady('No')
			setIsStarted('Yes')
			setStartDate('')
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
						setIsBroken('')

		} else if (meaning === 'NotStarted') {
			setIsReadyForNextStage('Yes')
			setIsReady('No')
			setIsStarted('No')
			setStartDate(moment().format('YYYY-MM-DD'))
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
						setIsBroken('')

		} else if (meaning === 'Expired') {
			setIsReadyForNextStage('Yes')
			setIsReady('No')
			setIsStarted('No')
			setStartDate('')
			setEndDate(moment().format('YYYY-MM-DD'))
			setCurrentPage(0)
						setIsBroken('')

		} else if (meaning === 'HasToDoToday') {
			setIsReadyForNextStage('Yes')
			setIsReady('No')
			setIsStarted('No')
			setStartDate(moment().format('YYYY-MM-DD'))
			setEndDate(moment().format('YYYY-MM-DD'))
			setCurrentPage(0)
						setIsBroken('')

		} else if (meaning === 'NotReadyForNextStage') {
			setIsReadyForNextStage('No')
			setIsReady('')
			setIsStarted('')
			setStartDate('')
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
						setIsBroken('')

		} else if (meaning === 'ClearAll') {
			setIsReadyForNextStage('')
			setIsReady('')
			setIsStarted('')
			setStartDate('')
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
						setIsBroken('')

		}
	}

	const handleRowClick = (record) => {
		setSelectedRowData(record)
		setIsModalVisible(true)
	}

	const handleStartBtn = async (serialNumber, index) => {
		if (!selectedService) {
			setIsLoaderModalVisible(false)
			message.error(t('selectService'))
			return
		}
		// let url = `api/pots/get-pots-lines?serialNumber=${serialNumber}&service=${selectedService}`
		// const { data } = await http.get(url)
		// const validData = data[0]

		const url = `api/pots/get-pots-lines?isProductionAllowed=Yes&serviceSerialNumber=${serialNumber}&isBroken=N&serviceCode=${selectedService}&pageSize=1000&skip=0`
		const { data } = await http.get(url)
		const validData = data?.filter(
			(item) =>
				item?.isReadyForNextStage === 'Yes' &&
				item?.isStarted !== 'Yes' &&
				item?.isReady !== 'Yes',
		)

		if (validData.length === 0) {
			setIsLoaderModalVisible(false)
			errorRef.current?.open(t('seriesNotFound'))
			return
		}

		if (validData) {
			// if (validData?.isReadyForNextStage === 'Yes') {
			// 	if (
			// 		validData?.isStarted === 'Yes' &&
			// 		validData?.isReady === 'Yes'
			// 	) {
			// 		setIsLoaderModalVisible(false)
			// 		errorRef.current?.open(t('alreadyFinished'))
			// 	} else {
			try {
				startTimePatch(validData, index)
			} catch (error) {
				setIsLoaderModalVisible(false)
			}
			// }
			// } else {
			// setIsLoaderModalVisible(false)
			// errorRef.current?.open(t('notReadyForNextStage'))
		} else {
			setIsLoaderModalVisible(false)
			errorRef.current?.open(t('seriesNotFound'))
		}
	}
	const handleMarkBroken = async (record, index) => {
		if (!selectedService) {
			setIsLoaderModalVisible(false)
			message.error(t('selectService'))
			return
		}


			try {
			markBroken(record, index)
			} catch (error) {
				setIsLoaderModalVisible(false)
			}
	}

	const handleEndBtn = async ({
		serialNumber,
		loadingForTableIndex,
		loadingForSerialIndex,
	}) => {
		const currentTime = moment().format('YYYY-MM-DD HH:mm:ss')
		const url = `api/pots/get-pots-lines?isProductionAllowed=Yes&serialNumber=${serialNumber}&isBroken=N&service=${selectedService}&pageSize=1000&skip=0`
		const { data } = await http.get(url)
		const validData = data[0]

		// const endData = activeTimers[serialNumber]
		const durationFromStart = calculateDurationString(
			`${validData?.docDate} ${validData?.startTime}`,
			currentTime,
		)

		try {
			endTimePatch(
				validData,
				currentTime,
				durationFromStart,
				serialNumber,
				loadingForTableIndex,
				loadingForSerialIndex,
			)
		} catch (error) {
			setIsLoaderModalVisible(false)
		}
	}

	const handleScan = async (serialNumber) => {
		setIsLoaderModalVisible(true)
		const currentTime = Date.now()

		if (lastScanTime && currentTime - lastScanTime < 300) {
			setIsLoaderModalVisible(false)
			return
		}
		setLastScanTime(currentTime)

		const isInProcess = productionWorkersInProcess?.some((order) =>
			order.lines?.some((line) => line.serialNumber === serialNumber),
		)

		if (isInProcess) {
			handleEndBtn({ serialNumber })
		} else {
			handleStartBtn(serialNumber)
		}
	}



	const lastKeyPressRef = useRef(0)
	const scannedCodeRef = useRef('')
	const handleScanRef = useRef()

	// Keep handleScanRef updated with the latest version of the handler
	useEffect(() => {
		handleScanRef.current = handleScan
	}, [handleScan])

	useEffect(() => {
		const handleKeyPress = (e) => {
			// Restore focus check to avoid capturing typing in search/inputs

			if (e.ctrlKey || e.metaKey || e.altKey) return

			const now = Date.now()
			const diff = now - lastKeyPressRef.current
			lastKeyPressRef.current = now

			// Clear buffer if gap is too long (500ms)
			if (
				diff > 500 &&
				scannedCodeRef.current.length > 0 &&
				e.key !== 'Enter'
			) {
				scannedCodeRef.current = ''
			}

			// Handle Enter
			if (e.key === 'Enter') {
				if (scannedCodeRef.current) {
					handleScanRef.current(scannedCodeRef.current)
					// message.info('Scanned code: ' + scannedCodeRef.current)
					scannedCodeRef.current = ''
				}
				return
			}

			// Accept numbers (0-9) and "o"/"O"
			if (/^[0-9oObB]$/.test(e.key)) {
				scannedCodeRef.current += e.key
				// message.info('Scanned code: ' + e.key)
			}
		}

		window.addEventListener('keydown', handleKeyPress)
		return () => window.removeEventListener('keydown', handleKeyPress)
	}, []) // ✅ EMPTY dependencies = listener is NEVER swapped, so no characters can be dropped.


	const handleDocNumChange = (val) => {
		debouncedSet(val, setDocNum)
	}

	const columns = columnProductionWorkers(
		t,
		handleRowClick,
		handleStartBtn,
		handleEndBtn,
		handleNavigateSeriesProdWorkers,
		handleDocNumChange,
		handleMarshrutWorkers,
		true,
		true,
		loadingDataForTable,
		handleMarkBroken,
	)

	const meaningBg = meaningOfBg(t)

	const handleReplaceService = () => {
		// setSelectedService('')
		setSelectServiceModal(true)
	}



	const handlePaginationChange = (page, pageSize) => {
		changePagination({
			page,
			pageSize,
			setCurrentPage,
			setPageSize,
		})
	}


	const handlePageSizeChange = (current, pageSize) => {
		changePageSize({
			current,
			pageSize,
			setCurrentPage,
			setPageSize,
		})
	}

	return (
		<Layout>
			<div className="mx-2 my-4 sm:m-5 border-[2px] border-gray-200">
				<h1 className="font-poppins px-3 sm:px-10 mt-6 sm:mt-14 text-xl font-bold text-black sm:text-2xl">
					{t('production')}
				</h1>

				<div className="mt-10 w-full border-[1px] border-[#E8E8E8] sm:mt-14" />


				<div className="mt-5">
					<div className="mt-5 px-3 sm:px-10 flex flex-wrap gap-3 items-end">
						<div className="flex flex-col gap-3 flex-1 min-w-[160px]">
							<span className="font-bold text-sm">
								{t('docNum')}
							</span>
							<Input
								className="w-full sm:w-[250px] h-8"
								placeholder={t('docNum')}
								onChange={(e) => {
									setInputDocNum(e.target.value)
									handleDocNumChange(e.target.value)
								}}
								value={inputDocNum}
							/>
						</div>
									<Button
						type="primary"
						className="w-[130px] bg-[#0A4D68]  rounded-lg text-white"
						onClick={() => {
							refetch()
							setCurrentPage(0)
							// refetchWithWhs()
						}}
					>
						<div className="flex items-center gap-2">
							<RefreshCcw size={16} />
							<span>{t('refetch')}</span>
						</div>
					</Button>
						<Button
							className="bg-[#0A4D68] text-white disabled:bg-gray-200 disabled:text-gray-400"
							onClick={handleReplaceService}
							disabled={
								serviceCodes.length === 0 ||
								serviceCodes.length === 1
							}
						>
							{t('replaceSelectedService')}
						</Button>
						<Button
							icon={<Camera size={18} />}
							onClick={() => setIsCameraModalVisible(true)}
							className="bg-[#0A4D68] text-white flex items-center gap-2"
						>
							{t('scanBarcode')}
						</Button>
					</div>
					<div className="mt-6 mb-4 px-3 sm:px-10 flex flex-col gap-3">
						<div className="flex gap-3 flex-wrap">
							{meaningBg.map((item, index) => (
								<div
									key={index}
									className="flex gap-1 items-center cursor-pointer"
									onClick={() => handleFilter(item.key)}
								>
									<div
										className={`rounded-full ${item.className} w-[20px] h-[20px] flex-shrink-0`}
									></div>
									<span className="text-sm">{item.meaning}</span>
								</div>
							))}
						</div>
					</div>
					<div className="flex justify-center sm:justify-end px-3 sm:px-10 mt-4 mb-4 overflow-x-auto">
						<Pagination
							showTotal={(total) =>
								t('totalPaginationItems', { total })
							}
							showSizeChanger={true}
							current={currentPage + 1}
							onShowSizeChange={(pageSize, current) => {
								handlePageSizeChange(current, pageSize)
							}}
							total={mappedData[0]?.documentsCount || 0}
							pageSize={mappedData[0]?.pageSize || 10}
							onChange={(page, pageSize) => {
								handlePaginationChange(page, pageSize)
							}}
						/>
					</div>

					<div className="px-2 sm:px-10 mb-5 overflow-x-auto">
						<Table
							columns={columns}
							dataSource={mappedData}
							pagination={false}
							className="mt-4 w-full ant-table-override"
							rowKey={(record, index) => index}
							bordered
							scroll={{ x: 900 }}
							loading={isLoading}
							rowClassName={switchBgColor}
						/>
					</div>
				</div>
			</div>

			{isLoaderModalVisible && (
				<Modal
					open={isLoaderModalVisible}
					footer={null}
					onCancel={() => {
						setIsLoaderModalVisible(false)
					}}
				>
					<div className="flex items-center justify-center">
						<div className="flex flex-col items-center gap-2">
							<Spin text="Loading..." tip="Loading..." />
							<span className="animate-pulse">
								{t('loading')}
							</span>
						</div>
					</div>
				</Modal>
			)}

			<ViewProductionWorkersModal
				visible={isModalVisible}
				data={selectedRowData}
				onClose={() => {
					setIsModalVisible(false)
				}}
			/>
			<SuccessModalWithTimer
				getRef={(r) => {
					successRef.current = r
				}}
			/>
			<ErrorModalWithTimer
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			<SelectServiceModal
				visible={selectServiceModal}
				service={selectedService}
				handleSelect={(value) => {
					if (value) {
						setSelectedService(value)
						setSelectServiceModal(false)
					}
				}}
			/>
			<CameraScanner
				visible={isCameraModalVisible}
				onScan={(code) => handleScan(code)}
				onClose={() => setIsCameraModalVisible(false)}
			/>
		</Layout>
	)
}

export default memo(ProductionManagement)
